import React, { useContext, useEffect, useRef, useState } from "react";
import { IonActionSheet } from "@ionic/react";
import BitacoraInput from "../components/bitacora/BitacoraInput";
import { AppConfigContext } from "../context/AppConfigContext";
import { CapacitorContext } from "../context/CapacitorContext";
import { EntradasContext } from "../context/EntradasContext";
import AdjuntosService from "../services/AdjuntosService";
import Entradas from "../components/bitacora/Entradas";
import { MenuContext } from "../context/MenuContext";
import { AuthContext } from "../context/AuthContext";
import io from "socket.io-client";

let socket;

const FILTERS = [
  { label: "Todo", value: "todo", icon: "fa-list" },
  { label: "Conversación", value: "conversacion", icon: "fa-comment" },
  { label: "Estimaciones", value: "estimaciones", icon: "fa-file-invoice-dollar" },
  { label: "Retrasos", value: "retrasos", icon: "fa-exclamation-triangle" },
];

const Bitacora = ({ idProyecto }) => {
  const [filter, setFilter] = useState("todo");
  const [search, setSearch] = useState("");
  const [showActionSheet, setShowActionSheet] = useState(false);
  const searchTimeout = useRef(null);

  const { platform } = useContext(CapacitorContext);

  const {
    max,
    hasMore,
    entradas,
    getLength,
    getEntradas,
    postEntrada,
    appendEntrada,
    clearBitacora,
    resetEntradas,
  } = useContext(EntradasContext);

  const { user } = useContext(AuthContext);
  const { BASE_URL } = useContext(AppConfigContext);
  const { setButtons, setSelected } = useContext(MenuContext);

  const step = 20;

  useEffect(() => {
    fetchEntradas(0, filter, search);
    setupSockets();
    setButtons(null);
    getLength(idProyecto);
    setSelected({ title: "bitacora" });
    return () => {
      socket.disconnect();
      clearBitacora();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    resetEntradas();
    fetchEntradas(0, filter, search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const handleSearchChange = (value) => {
    setSearch(value);
    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      resetEntradas();
      fetchEntradas(0, filter, value);
    }, 400);
  };

  const setupSockets = () => {
    const url = BASE_URL.replace("/api", "");
    socket = io(url, { transports: ["websocket"] });
    socket.on("connection", () => {});
    socket.emit("join", { userId: user.uid, obraId: idProyecto });
    socket.on("message", (entrada) => {
      appendEntrada(entrada);
    });
  };

  const uploadEntrada = (message, files, tagged = []) => {
    if (tagged.length > 0) {
      tagged = tagged.filter((usuario) => message.includes(`@${usuario.nombre}`));
    }
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        let formData = new FormData();
        formData.append("adjunto", files[i]);
        AdjuntosService.postAdjuntoBitacora(idProyecto, formData).then((res) => {
          const { idAdjunto } = res.data;
          postEntrada(idProyecto, { idAdjunto });
        });
        if (message && message !== null && message !== "") {
          postEntrada(idProyecto, { message, tagged });
          socket.emit("sendMessage", { message, userId: user.uid, obraId: idProyecto });
        }
      }
    } else {
      postEntrada(idProyecto, { message, tagged });
      socket.emit("sendMessage", { message, userId: user.uid, obraId: idProyecto });
    }
  };

  const fetchEntradas = (offset = 0, activeFilter = filter, activeSearch = search) => {
    const params = {};
    if (activeFilter !== "todo") params.filter = activeFilter;
    if (activeSearch.trim() !== "") params.search = activeSearch.trim();
    getEntradas(idProyecto, offset, step, params);
  };

  return (
    <div className="container-fluid h-100 px-md-3 px-0 position-relative d-flex flex-column">
      <div className="px-2 pt-2 pb-1">
        <div className="card shadow-sm overflow-hidden">
          <div className="px-2 pt-2 pb-1">
            <div className="d-flex gap-2">
              <div className="input-group input-group-sm">
                <span className="input-group-text bg-white border-end-0">
                  <i className="fa fa-search text-muted" style={{ fontSize: 12 }} />
                </span>
                <input
                  type="text"
                  className="form-control border-start-0 ps-0"
                  placeholder="Buscar en bitácora..."
                  value={search}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  style={{ fontSize: 13 }}
                />
                {search !== "" && (
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => handleSearchChange("")}
                  >
                    <i className="fa fa-times" style={{ fontSize: 11 }} />
                  </button>
                )}
              </div>
              {platform !== "web" && (
                <button
                  className={`btn btn-sm flex-shrink-0 ${filter !== "todo" ? "btn-primary" : "btn-outline-secondary"}`}
                  onClick={() => setShowActionSheet(true)}
                  style={{ width: 34 }}
                >
                  <i className="fa fa-filter" />
                </button>
              )}
            </div>
          </div>
          {platform === "web" && (
            <div className="d-flex" style={{ borderTop: "1px solid rgba(0,0,0,0.07)" }}>
              {FILTERS.map((f, i) => {
                const active = filter === f.value;
                return (
                  <button
                    key={f.value}
                    onClick={() => setFilter(f.value)}
                    className="btn btn-sm flex-fill rounded-0 py-2"
                    style={{
                      fontSize: 12,
                      fontWeight: active ? 600 : 400,
                      color: active ? "var(--primary)" : "#6c757d",
                      background: "transparent",
                      borderBottom: active ? "2px solid var(--primary)" : "2px solid transparent",
                      borderTop: "none",
                      borderLeft: i === 0 ? "none" : "1px solid rgba(0,0,0,0.07)",
                      borderRight: "none",
                      transition: "all 0.15s",
                    }}
                  >
                    <i className={`fa ${f.icon} me-1`} style={{ fontSize: 11 }} />
                    {f.label}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <IonActionSheet
        isOpen={showActionSheet}
        onDidDismiss={() => setShowActionSheet(false)}
        header="Filtrar bitácora"
        buttons={[
          ...FILTERS.map((f) => ({
            text: f.value === filter ? `${f.label} ✓` : f.label,
            handler: () => setFilter(f.value),
          })),
          { text: "Cancelar", role: "cancel" },
        ]}
      />

      <div
        className="flex-grow-1 overflow-hidden"
        style={{ paddingBottom: platform !== "web" ? "150px" : "90px" }}
      >
        <Entradas
          scrollCallback={(offset) => fetchEntradas(offset, filter, search)}
          idUsuario={user.idUsuario}
          idProyecto={idProyecto}
          entradas={entradas}
          user={user}
          step={step}
          max={max}
          hasMore={hasMore}
        />
      </div>

      <div
        className="position-fixed start-0 end-0 px-2"
        style={{
          bottom:
            platform !== "web"
              ? "calc(env(safe-area-inset-bottom, 0px) + 70px)"
              : 0,
          zIndex: 1050,
        }}
      >
        <BitacoraInput modifier={uploadEntrada} />
      </div>
    </div>
  );
};

export default Bitacora;
